<span>{{ fieldValue | formatDate: format }}</span>
